module.exports =
  '_PRIVACY_POLICY':
    'TITLE': 'Privacy Policy'




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/policy/i18n/en.coffee